
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graveyard-consolidations",
      function () {
        return require("private-next-pages/graveyard-consolidations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graveyard-consolidations"])
      });
    }
  